module.exports = __webpack_public_path__ + "static/media/u-story-icon-v2.a20a1ce4.png";